// src/lib/http/client.js
import { BASE_URL } from "utils/constant";
import { AuthManager } from "utils/authUtils";
import { csrftoken } from "utils/DjangoCSRFToken";
const auth = new AuthManager(BASE_URL);

function buildUrl(path, params) {
  const isAbsolute = /^https?:\/\//i.test(path);
  const url = new URL(isAbsolute ? path : `${BASE_URL}${path}`);
  if (params)
    Object.entries(params).forEach(
      ([k, v]) => v != null && url.searchParams.append(k, v)
    );
  return url.toString();
}

async function rawFetch(path, { method = "GET", headers, body, params } = {}) {
  const url = buildUrl(path, params);
  const res = await fetch(url, {
    method,
    headers,
    body:
      body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
  });
  return res;
}

export async function http(path, options = {}, { retryOn401 = true } = {}) {
  const headers = new Headers(options.headers || {});
  if (!(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");

  const token = auth.getAccessToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-CSRFToken", csrftoken);
  }

  let res = await rawFetch(path, { ...options, headers });


  if (res.status === 401 && retryOn401) {
    const init = await auth.initialize(); // verify/refresh if needed
    if (!init.status) {
      localStorage.clear();
      window.location.href = "/login";
      return res;
    } // still unauthorized → caller will handle

    const freshHeaders = new Headers(options.headers || {});
    if (!(options.body instanceof FormData))
      freshHeaders.set("Content-Type", "application/json");
    freshHeaders.set("Authorization", `Bearer ${auth.getAccessToken()}`);

    res = await rawFetch(path, { ...options, headers: freshHeaders });
  }

  return res;
}

export async function json(path, options, opts) {
  const res = await http(path, options, opts);
  let data = null;
  try {
    data = await res.json();
  } catch (_) { }
  if (!res.ok) {
    const err = new Error(data?.detail || data?.message || res.statusText);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}